import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContantLoader from "../ContantLoader";
import { Container } from "reactstrap";
import {
  getSubscriberCount,
  getTag,
  getCompany,
  getPersons,
  filterPersonsData,
  getTagCount,
} from "api/AccountsApi";
import {
  setSearchEvent,
  setTagValue,
  setAccountLoading,
  setPersonData
} from "ReduxStore/Slices/accountSlice";

import { useDispatch, useSelector } from "react-redux";
import { exportPersons } from 'api/ExportApi'

import Table from "../Table";

import CreateAccountModal from "./CreateAccountModal"
import { addPerson, getLabels, getPersonById } from 'api/AccountsApi';
import { toast } from "react-toastify";
import 'styles.css'
import {GET , POST , PUT} from '../../api/API'

const Account = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [subscribe, setSubscribe] = useState("");
  const [tags, setTags] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [styleWidth, setStyleWidth] = useState(150);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageSizeState, setPageSizeState] = useState(10);
  const [showContactModel, setShowContactModal] = useState(false);
  const [newContact, setNewContact] = useState([]);
  const [schema, setSchema] = useState([]);

  const [mtags, setmTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tagList, setTagList] = useState([]);

  const [pendingRevenue, setPendingRevenue] = useState();

  // const [searchLoading, setSearchLoading] = useState(false);

  const searchText = useRef("");
  const tagValue = useRef("");
  const dispatch = useDispatch();
  const { searchEvent, filterTagValue, accountLoading } = useSelector(
    (state) => state.accountSetter
  );
  const { role , companyType } = useSelector(
    (state) => state.userSetter
  );

  const TagsFormatter = (data) => {
    console.log("datallllllll", data)
    data.forEach((obj) => {
      let tags = "";
      obj.tags && obj.tags.forEach((tag) => {
        tags += tag + "  ";
      });
      obj.leadGenRevenue = obj.leadGenRevenue? '$'+ Number.parseFloat(obj.leadGenRevenue).toFixed(2) : '';

      obj.tags = tags;
    });
  };

  const columns = useMemo(
    () => (role== 'publisher' || role == 'partner')? [
      {
        Header: "Email",
        accessor: "email",
        className: "first_column",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header:"Payment Status",
        accessor:"paymentStatus"
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Rev-share Amount",
        accessor: "leadGenRevenue",
      },
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
      {
        Header: "Campaign Name",
        accessor: "campaignName",
      },
      {
        Header: "Referral Name",
        accessor: "referralName",
      },
      {
        Header: "Referral Email",
        accessor: "referralEmail",
      },
      {
        Header: "Source Type",
        accessor: "sourceType",
      },
      {
        Header: "Publisher Url",
        accessor: "publisherUrl",
      },
     
      {
        // width: 300,
        Header: "",
        accessor: "name_2",
        Cell: ({ cell }) => (
          role!='publisher' && role != 'partner' &&  <a
            onClick={() => getPersonData(cell.row.original)}
            style={{
              color: "#2C40CE",
              cursor: "pointer",
              width: "100%",
              textAlign: "start",
            }}
          >
            Details
          </a> 
        ),
      },
    ]: companyType =='lead'?[
      {
        Header: "Email",
        accessor: "email",
        className: "first_column",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
     
      {
        // width: 300,
        Header: "",
        accessor: "name_2",
        Cell: ({ cell }) => (
          role!='publisher' && role != 'partner' &&  <a
            onClick={() => getPersonData(cell.row.original)}
            style={{
              color: "#2C40CE",
              cursor: "pointer",
              width: "100%",
              textAlign: "start",
            }}
          >
            Details
          </a> 
        ),
      },

    ]: [
      {
        Header: "Email",
        accessor: "email",
        className: "first_column",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
      {
        Header: "Tags",
        accessor: "tags",
      },

     
      {
        Header: "Email Marketing",
        accessor: "emailMarketing",
        Cell: ({ cell }) => (

          (
            <a>
              {cell.row.original.emailMarketing == "Active"
                ? <div className="sub" >
                  <div className="circle">
                  </div>
                  <span> Subscribed</span>
                </div>
                :  <div className="unsub" >
                <div className="circle">
                </div>
                <span> Unsubscribed</span>
              </div>}
            </a>
          )
        ),
      },
      {
        // width: 300,
        Header: "",
        accessor: "name_2",
        Cell: ({ cell }) => (
          role!='publisher' && role != 'partner' &&  <a
            onClick={() => getPersonData(cell.row.original)}
            style={{
              color: "#2C40CE",
              cursor: "pointer",
              width: "100%",
              textAlign: "start",
            }}
          >
            Details
          </a> 
        ),
      },
    ],
    []
  );

  const data = useMemo(() => dataApi, [dataApi]);

  useEffect(() => {
    dispatch(setAccountLoading(true));
    getTag()
      .then((data) => {
        setTags(data);

        let url = window.location.href;
        let tag = url.split("?")[1] || sessionStorage.getItem("E__tag") || null;

        console.log("tag E__tag", tag ,data.find((a) => a.tag == tag));

        if (data.find((a) => a.tag == tag)) {
          console.log("tag E__tag", tag);

        //   setTimeout(() => {


        //     tagValue.current.value = tag;

        //     console.log("D#d3", tagValue.current.value, tagValue.current)


        //     dispatch(setAccountLoading(true));
        //     dispatch(setSearchEvent("tag"));
        //     dispatch(setTagValue(tag));
        //     fetchData({
        //       pageSize: 10,
        //       pageIndex: 0,
        //       event: "filter",
        //       e: tag,
        //     });
        // }, 2000)
        }
      })
      .catch((e) => { })
    getCompany()
      .then((data) => {
        setCompanyName(data.name);
      })
      .catch((e) => { })

  }, []);

  function AmountFormatter(data) {
    console.log("GOOOOOOOOOOOOOOOOOO",data)

    data.forEach((obj) => {
      obj.leadGenRevenue = obj.leadGenRevenue? '$'+ obj.leadGenRevenue : '';
    });
    console.log("GOOOOOOOOOOOOOOOOOO",data)
  }
  const fetchData = useCallback(
    async ({ pageSize, pageIndex }) => {
      dispatch(setAccountLoading(true));
      const startRow = pageSize * pageIndex;
      const endRow = startRow + pageSize;

      console.log("TAAAA", filterTagValue, searchEvent)


      if ( sessionStorage.getItem("E__tag") ){
        let ttt = sessionStorage.getItem("E__tag")
        sessionStorage.removeItem("E__tag");
          tagValue.current.value = ttt;
          dispatch(setTagValue(ttt));

          setTimeout(() => {
 
            tagValue.current.value = ttt;
          }, 6000)

        

       await getTagCount(ttt).then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
        });
        filterPersonsData(ttt, pageSize, startRow)
          .then((data) => {
            TagsFormatter(data);
            setDataApi(data);
            // setSearchLoading(false);
            dispatch(setAccountLoading(false));
          })
          .catch((e) => { })
      }


      else if (searchEvent == "tag") {
        if (filterTagValue === "Please Select") {
          await getPersons(pageSize, startRow, null,(role=='publisher' || role == 'partner')? true : null)
            .then((data) => {

              data.forEach((obj) => {
                obj.paymentStatus  = obj.paymentStatus =='RefundAdjusted' ? 'Refunded' : obj.paymentStatus;

                if (obj.paymentStatus =='Refunded' )
                  obj.strike = true;
            })
              TagsFormatter(data);
              setDataApi(data);
              AmountFormatter(data);
              dispatch(setAccountLoading(false));
            })
            .catch((e) => { })
          await getSubscriberCount()
            .then((data) => {
              setSubscribe(data);
              setPageCount(Math.ceil(data.overallPerson / pageSize));
            })
            .catch((e) => { })
        } else if (filterTagValue !== null) {
          await selectTagHandler(pageSize, startRow);
        }
      } else if (searchEvent == "search") {
        await searchHandler(pageSize, startRow);
      }
  
        setPageSizeState(pageSize)
      console.log("new s",pageSize)
    
      setPageIndex(pageIndex);
    },
    [searchEvent, filterTagValue]
  );

  const searchHandler = (pageSize, startRow) => {
    searchText.current.value !== ""
      ? getPersons(pageSize, startRow, searchText.current.value,(role=='publisher' || role == 'partner')? true : null)
        .then((data) => {
          data.forEach((obj) => {
            obj.paymentStatus  = obj.paymentStatus =='RefundAdjusted' ? 'Refunded' : obj.paymentStatus;

            if (obj.paymentStatus =='Refunded' )
              obj.strike = true;
        })
          TagsFormatter(data);
          setDataApi(data);
          // setSearchLoading(false);
          dispatch(setAccountLoading(false));
        })
        .catch((e) => { })
      : getPersons(pageSize, startRow,null,(role=='publisher' || role == 'partner')? true : null)
        .then((data) => {
          data.forEach((obj) => {
            obj.paymentStatus  = obj.paymentStatus =='RefundAdjusted' ? 'Refunded' : obj.paymentStatus;

            if (obj.paymentStatus =='Refunded' )
              obj.strike = true;
        })
          TagsFormatter(data);
          setDataApi(data);
          // setSearchLoading(false);
          dispatch(setAccountLoading(false));
        })
        .catch((e) => { })

    searchText.current.value !== ""
      ? getSubscriberCount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
        })
        .catch((e) => { })
      : getSubscriberCount()
        .then((data) => {
          setSubscribe(data);
          setPageCount(Math.ceil(data.overallPerson / pageSize));
        })
        .catch((e) => { })
  };

  const selectTagHandler = (pageSize, startRow) => {
    getTagCount(tagValue.current.value).then((data) => {
      setPageCount(Math.ceil(data.count / pageSize));
    });
    filterPersonsData(tagValue.current.value, pageSize, startRow)
      .then((data) => {
        TagsFormatter(data);
        setDataApi(data);
        // setSearchLoading(false);
        dispatch(setAccountLoading(false));
      })
      .catch((e) => { })
  };

  const getPersonData = (e) => {

    // e.tagList = tags;

    // sessionStorage.setItem("personDetails", e);
    // dispatch(setPersonData(e));
    // props.history.push(`/admin/contact/details?id=${e.id}`, e);
    window.open(`/admin/contact/details?id=${e.id}`, '_blank').focus();

  };
  function updateRole() {
    let t = localStorage.getItem('role');
    setIsAdmin(t === 'admin');
  }
  useEffect(() => {
    updateRole()
    window.addEventListener('storage', updateRole)

  }, [])

  function closeModel() {
    setShowContactModal(false)
    let temp = schema.map(label => {
      return { label: label.label, key: label.key, value: null }
    })
    setNewContact(temp)
  }
  function saveField(attr) {
    let temp = [...newContact]
    temp.find(a => a.key == attr.key).value= attr.value
    setNewContact(temp)
    
  }
  function handleSave() {
    console.log(mtags)
    let data = newContact.map(a=> {

      return {key :a.label , value : a.value && typeof a.value == 'string'? a.value.trim() : a.value}
    }
      )

    addPerson({ data: data , tags:mtags.map(t=> t.value) }).then(r=>{
      toast.success("The Contact has been saved successfully!");
      closeModel()

      let id = r.id;
      let person = {};
      newContact.forEach(a =>{
        person[a.key] = a.value;
      })
      person.tagList = tags;

      // props.history.push(`/admin/contact/details?id=${id}&tab=profile`,person);
      // // setTimeout(()=>{
      // //   try{
      // //     let el = document.getElementById('profileTabLink')
      // //     el.click();
      // //   }catch(e){
      // //   }
      // },2000)



    }).catch((e) => {
      console.log("kk",e)
      toast.error(e.response.data.message||"Something went wrong !!");

});


  }
  useEffect(() => {
    getLabels().then(labels =>{
      setSchema(labels)
      let temp = labels.map(label =>{
        return {label: label.label , key: label.key , value: null}
      })
      setNewContact(temp)
    })




  },[])

  useEffect(() => {
    GET("leads/pendingRevenue")
    .then((data) => {
      setPendingRevenue(data.pendingRevenue);

    })
    .catch(err => {
      console.log("ERROR => ", err);
    })
  },[])


  return (
    <Container>
      {showContactModel && <CreateAccountModal data={newContact} handleClose={closeModel} handleSave={handleSave} saveField={saveField} tags={mtags} setTags={setmTags} setTagList={setTagList} tagList={tags.map(t =>{ return { value: t.tag, label: t.tag } })   } />}
      
      
      <div className="top-header-cont">
      <div className="page_heading">
        <h2>Contact List</h2>
        
        {dataApi ? (
          <div>
            <div style={{display:"flex" , justifyContent:"space-between",marginBottom:"4px"}}>
            <p>{companyName}</p>
            </div>
            {
              (role === 'publisher' || role === 'partner') ? (
                <p className="sm">
                  Payout Available: ${pendingRevenue}
                </p>
              ) : (
                <p className="sm">
                  You have {subscribe.overallPerson} contacts and{" "}
                  {subscribe.overallSubscriber} subscribers.
                </p>
              )
            }
          </div>
        ) : null}
      </div>

        <div className="joifo">
          
        <div className="search_bar_wrap d-flex">
            {/* <label className="search_label mr-3">Search</label> */}
            <input
              className="form-control search-input"
              id="search_input"
              placeholder="Enter Name or Email "
              ref={searchText}
              style={{ maxWidth: "23%", marginLeft: "25px" }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  // setSearchLoading(true);
                  dispatch(setAccountLoading(true));
                  dispatch(setSearchEvent("search"));
                  fetchData({
                    pageSize: pageSizeState,
                    pageIndex: 0,
                    event: "search",
                  });
                }
              }}
            />
            <button
              onClick={() => {
                // setSearchLoading(true);
                dispatch(setAccountLoading(true));
                dispatch(setSearchEvent("search"));

                fetchData({
                  pageSize: pageSizeState,
                  pageIndex: 0,
                  event: "search",
                });
              }}
              className="lg_btn tertiary search_btn"
              style={{ height: "38px", margin: "0 4px 1vh 1vh" }}
            >
              {accountLoading ? "Loading..." : "Search"}
            </button>

            <div className="separator-vert">

            </div>
          
          </div>

          
          {isAdmin && <input
              onClick={exportPersons}
              type="submit"
              name="Save"
              style={{
                // margin_top: "2v",
                // cursor: "pointer",
                // borderRadius: "6px",
                // padding: "0px",
                // minWidth: "90px",
                // fontSize: "13px",
                // margin: "0 12px",
                // marginTop:"5px",
                //  position: "absolute",
                // right: "0",
                // top:"-3px"
              }}
              className="bttn_newdes add__stage lg_btn tertiary "
              value="Export"
            />  }
          {role!='publisher' && role != 'partner' &&<button
              type='submit'
              name='Save'
              style={{
                // margin_top: '2v',
                cursor: 'pointer',
                padding: '12px 29px',
                margin: "4px !important"

              }}
              className='add lg_btn primary btn bttn_newdes'
              onClick={() => {
                setShowContactModal(true);
              }}
            >
              <i class='fa fa-plus plus mr-2' aria-hidden='true'></i>
              Create Contact
            </button>}

        </div>

      </div>
   



      <div >

      </div>
      {dataApi ? (
        <div className="dataTableOuter account_table">
   
  
          <div className="table-flter rdt_Pagination d-flex align-items-center">
            <span className="inline-label mr-2">Filter by Tags</span>
            <select
              onChange={(e) => {
                // setSearchLoading(true);
                dispatch(setAccountLoading(true));
                dispatch(setSearchEvent("tag"));
                console.log("KSSSSSSSSSSSSSS")
                dispatch(setTagValue(e.target.value));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  event: "filter",
                  e: e.target.value,
                });
              }}
              className="sc-kEYyzF iWaZxR kw_select_tag"
              style={{ width: `${styleWidth}px` }}
              ref={tagValue}
            >
              <option default id="default1">
                All tags
              </option>
              {tags
                ? tags.map((tag, index) => (
                  <option key={index} value={tag.tag} >{tag.tag}</option>
                ))
                : ""}
            </select>

            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          <div>
            {" "}
            {
              <div>
                {
                  <Table
                    columns={columns}
                    data={data}
                    pageCount={pageCount}
                    fetchData={fetchData}
                    loading={accountLoading}
                  ></Table>
                }
              </div>
            }
          </div>
        </div>
      ) : (
        <ContantLoader />
      )}
    </Container>
  );
};

export default Account;